export default __webpack_public_path__ + "static/media/loudspeaker.fcef1c9f.png";